import { ChangeEvent, ReactElement, useEffect, useState } from "react";
import { ISample, IState } from "../../../../types";
import { Tab, Tabs } from "@mui/material";
import SamplePanel from "../../../production/components/heatPanels/samplesPanel";
import TabPanel from "../../../../components/tabPanel";
import { useSelector } from "react-redux";

interface IProps {
  steelCode: string;
  samples: ISample[];
}

interface IModel {
  machine: string;
  zone: string;
  samples: ISample[];
}

const SamplesByMachine = ({ samples, steelCode }: IProps): ReactElement => {
  const darkMode = useSelector((state: IState) => state.darkMode);
  const [ model, setModel ] = useState<IModel[]>([]);
  const [ tab, setTab ] = useState<number>(0);


  useEffect(() => {
    const newModel: IModel[] = [];
    const sorted = samples.sort((a, b) => a.productionMachineID - b.productionMachineID);

    sorted.map(item => {
      let machine = newModel.find(x => x.machine === item.sampleType.machine);
      if (!machine) {
        machine = {
          machine: item.sampleType.machine,
          zone: item.sampleType.machine,
          samples: [ item ]
        };

        newModel.push(machine);
      } else {
        machine.samples.push(item);
      }
    });

    setModel(newModel);
  }, [ samples ]);


  const handleChange = (_event: ChangeEvent<any>, newValue: number) => {
    setTab(newValue);
  };

  return (
    <>
      <Tabs
        value={tab}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
        centered={true}
        style={{ background: darkMode ? "rgba(255, 255, 255, 0.2)" : "rgba(0, 0, 0, 0.2)" }}>
        { model.map(item => <Tab key={`sample-tab-machine-${item.machine}`} label={item.machine} />) }
      </Tabs>
      {model.map((item, index) => {
        return (
          <TabPanel key={`sample-tab-panel-machine-${item.machine}`} value={tab} index={index}>
            <SamplePanel samples={item.samples} steelCode={steelCode} zoneCode={item.zone}/>
          </TabPanel>
        );
      })}
    </>
  );
};

export default SamplesByMachine;
